import React from 'react';
type LazyImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'loading' | 'decoding'> & {
  src: string;
  alt: string;
  width: number;
  height: number;
  /** Imagen visible al cargar la página (hero): se descarga con prioridad alta. */
  priority?: boolean;
};

// Imagen optimizada: lazy-loading nativo, decodificación asíncrona y
// dimensiones intrínsecas para reservar espacio y evitar saltos de layout.
export function LazyImage({
  priority = false,
  ...rest
}: LazyImageProps) {
  const priorityAttrs = priority ? {
    fetchpriority: 'high'
  } : {};
  return <img {...rest} {...priorityAttrs} loading={priority ? 'eager' : 'lazy'} decoding="async" data-id="element-45" data-mp="28ujzdblxlbvg" />;
}